import { Slider as MuiSlider } from '@mui/material';

import styled from 'styled-components';

type SliderProps = { $color?: string };
const SliderColor = ({ $color }: SliderProps) => $color;
export const Slider = styled(MuiSlider)<SliderProps>`
  color: ${SliderColor};

  .MuiSlider-track {
    background-color: ${SliderColor};
    border-color: ${SliderColor};
  }

  .MuiSlider-rail {
    background-color: ${SliderColor};
  }

  .MuiSlider-thumb {
    background-color: ${SliderColor};
  }

  .MuiSlider-valueLabel {
    background-color: ${SliderColor};
  }

  .MuiSlider-markLabel {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;
